import { render, staticRenderFns } from "./BotonEliminar.vue?vue&type=template&id=aae8b18e"
import script from "./BotonEliminar.vue?vue&type=script&lang=js"
export * from "./BotonEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports